import React from 'react';

import 'ui-kit/icons/social-media-icons/social-media-icon.style.css';

const Facebook = ({ variant }) => {
    const getVariantStyle = () => {
        switch (variant) {
            case 'light': {
                return { fill: 'rgb(255,255,255)', height: '25', width: '11.842' };
            }
            case 'primary': {
                return { fill: 'rgb(3,164,220)', height: '25', width: '11.842' };
            }
            default: {
                return { fill: 'rgb(3,164,220)', height: '100%', width: '100%' };
            }
        }
    };

    const variantStyle = getVariantStyle();

    return (
        <svg
            className="social-media-icon facebook"
            xmlns="http://www.w3.org/2000/svg"
            width={variantStyle.width}
            height={variantStyle.height}
            viewBox="0 0 11.842 25"
        >
            <path
                fill={variantStyle.fill}
                fillRule="evenodd"
                d="M10.7132369 4.86653646c.15414729.03255208.3237093 0 .46244187-.09765625s.23122094-.26041667.24663567-.42317708l.4161977-3.17382813c.03082945-.29296875-.13873257-.60221354-.43161243-.68359375C10.32786866.16276042 9.15634923 0 7.93858561 0 4.2544653 0 2.4663567 1.85546875 2.4663567 5.69661458v1.6764323H.58575971C.2620504 7.37304688 0 7.64973957 0 7.99153646v3.25520833c0 .35807292.2620504.63476563.58575971.63476563H2.4663567v12.5c0 .34179687.2620504.61848958.58575972.61848958h3.85368234c.30829458 0 .57034498-.2766927.57034498-.61848958v-12.5h3.11377533c.30829458 0 .55493025-.26041667.58575971-.5859375l.21580621-3.25520834c.01541473-.17903646-.04624418-.34179687-.15414729-.4720052-.1079031-.13020834-.2620504-.1953125-.4161977-.1953125H7.47614374V5.9407552c0-1.07421875.1079031-1.33463542 1.1561047-1.33463542.60117445 0 1.4181551.1139323 2.08098846.26041667z"
            />
        </svg>
    );
};

export default Facebook;
